const dateFormat = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const dateTimeFormat = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

/**
 * Datum in deutscher Schreibweise: 31.08.2026.
 * Leere oder ungültige Werte ergeben einen Gedankenstrich statt "Invalid Date".
 *
 * @example
 * ```tsx
 * <td>{formatDate(vorgang.faelligAm)}</td>
 * ```
 */
export function formatDate(value: string | Date | null | undefined): string {
  const date = toDate(value)
  return date ? dateFormat.format(date) : '–'
}

/**
 * Datum mit Uhrzeit: 31.08.2026, 14:05.
 *
 * @example
 * ```tsx
 * <span>Zuletzt geändert: {formatDateTime(vorgang.geaendertAm)}</span>
 * ```
 */
export function formatDateTime(value: string | Date | null | undefined): string {
  const date = toDate(value)
  return date ? dateTimeFormat.format(date) : '–'
}

/**
 * Zahl in deutscher Schreibweise: 1.234,50.
 *
 * @example
 * ```tsx
 * <td className="text-right">{formatNumber(vorgang.menge)}</td>
 * ```
 */
export function formatNumber(
  value: number | null | undefined,
  fractionDigits = 0,
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '–'
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value)
}

function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null
  const date = value instanceof Date ? value : new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}
